import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';

export const useReliabilityCapabilities = () => {
  const {
    hasReliabilityMetrics,
    isCapabilitiesLoading,
    refetchCapabilities,
    capabilitiesError,
  } = useCostReportContext();

  const showNotInstalled = !isCapabilitiesLoading && !hasReliabilityMetrics;

  return {
    hasReliabilityMetrics,
    isCapabilitiesLoading,
    showNotInstalled,
    refetchCapabilities,
    capabilitiesError,
  };
};
